import { Archive, Print } from "@mui/icons-material";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Drawer,
    IconButton,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import OrderCartItem from "../../pages/PosPage/components/OrderCartItem";
import { useLoadDoctype } from "../../shared/hooks/useFrappeDoctype";
import { useTodayClosedInvoices } from "../../shared/hooks/useInvoicesData";
import {
    useGetAllTables,
    usePrintOrder,
} from "../../shared/hooks/useTablesData";
import { PosContext } from "../../shared/PosContext";
import { dateTimeFormat } from "../../utils/dateUtils";
import { getOrderShortName } from "../../utils/floorUtils";
import SimpleWidgetsHeader from "../SimpleWidgetsHeader/SimpleWidgetsHeader";
import Spinner from "../Spinner";
import { useStyles } from "./styles";

function ClosedOrders({ open, onClose }) {
    const classes = useStyles();
    const { settingsInvoicePrinter } = useContext(AppContext);

    const { data: allTables } = useGetAllTables();
    const { data: closedInvoices } = useTodayClosedInvoices();
    const printOrderMutation = usePrintOrder();

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [printingOrder, setPrintingOrder] = useState(null);

    const { data: invoiceData } = useLoadDoctype(
        "POS Invoice",
        selectedInvoice
    );

    const [orders, setOrders] = useState([]);

    useEffect(() => {
        if (closedInvoices && allTables) {
            const returnedInvoices = closedInvoices
                .filter((i) => i.status === "Return")
                .map((i) => i.return_against);
            const _closedInvoices = closedInvoices.filter(
                (i) =>
                    !i.return_against &&
                    i.status === "Paid" &&
                    !returnedInvoices.includes(i.name)
            );

            setOrders(
                _closedInvoices.map((i) => {
                    const _invoice = { ...i };
                    const _table = allTables.find(
                        (t) =>
                            t.name ===
                            _invoice.customer_name.split("-").slice(-1)[0]
                    ) || { description: "takeaway" };
                    return { ..._invoice, table: _table.description };
                })
            );
        }
    }, [closedInvoices, allTables]);

    const handlePrint = (order) => {
        if (!settingsInvoicePrinter) {
            setPrintingOrder(order.name);
            
            const printUrl = `/api/method/frappe.utils.print_format.download_pdf?doctype=POS%20Invoice&name=${order.name}&format=POS&no_letterhead=0&settings=%7B%7D&_lang=en`;
            // const printUrl = `/api/method/frappe.utils.print_format.download_pdf?doctype=POS%20Invoice&name=${order.name}&format=POS%20Invoice&no_letterhead=0&letterhead=Antico&settings=%7B%7D&_lang=en`;

            // Create a hidden iframe to handle the PDF printing
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = printUrl;
            document.body.appendChild(iframe);

            // Wait for the iframe to load and then print
            iframe.onload = () => {
                try {
                    iframe.contentWindow.print();
                } catch (error) {
                    console.error(
                        "Error printing invoice:",
                        error
                    );
                }
                // Clear the loading state
                setPrintingOrder(null);
                // Clean up the iframe after printing
                // setTimeout(() => {
                // document.body.removeChild(iframe);
                // }, 1000);
            };
        } else {
            printOrderMutation.mutate(
                {
                    orderId: order.name,
                    doctype: "POS Invoice",
                },
                {
                    onSuccess: () => {
                        console.log("printed");
                    },
                    onError: (err) => {
                        console.log(err);
                    },
                }
            );
        }
    };

    const InvoiceView = () => {
        const items = invoiceData.docs[0].custom_order_items || [];
        const cartItems = [];

        const { getMenuItem, addonsItems } = useContext(PosContext);

        let total = 0;

        items.forEach((item) => {
            total += item.qty * item.rate;
        });

        items.forEach((i) => {
            const menuItem = getMenuItem(i.item_code);
            if (menuItem) {
                const itemAddons = [];
                const addonsArray = i.addons ? JSON.parse(i.addons) : [];

                if (addonsArray && addonsArray.length > 0) {
                    addonsArray.map((ad) => {
                        itemAddons.push(
                            addonsItems.find((entry) => entry.item_code === ad)
                        );
                    });
                }
                cartItems.push({
                    item: {
                        ...i,
                        cover: menuItem.cover,
                        standard_rate: menuItem.standard_rate,
                    },
                    addons: itemAddons,
                    qty: i.qty,
                    entry_name: menuItem.identifier,
                });
            }
        });
        return (
            <div className={classes.OrderWidget}>
                <div className={classes.OrderCartItems}>
                    {cartItems.map((item, idx) => {
                        return (
                            <OrderCartItem
                                key={`order-item-${idx}`}
                                item={item}
                            />
                        );
                    })}

                    <div className="Pricing__Total">
                        <div>
                            <span>Total</span>
                            <span>{total}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            <Drawer
                className={classes.Drawer}
                anchor="right"
                open={open}
                onClose={onClose}
            >
                <div className={classes.DrawerWrapper}>
                    <SimpleWidgetsHeader
                        onClose={onClose}
                        Icon={Archive}
                        title="Closed Orders"
                        // action={newTakeawayOrder}
                    />

                    <div className={classes.OrderItems}>
                        <div className="Orders__List">
                            <div className="Orders__List_RowWrapper">
                                <div className="Orders__List_header">
                                    <div>Table</div>
                                    <div>Order</div>
                                    <div>Total</div>
                                    <div>Time</div>
                                    <div>Total Items</div>
                                </div>
                                <span className="Orders__List_Action">
                                    <IconButton
                                        style={{ visibility: "hidden" }}
                                    >
                                        <Print />
                                    </IconButton>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className={classes.OrderItems}>
                        <div className="Orders__List  md">
                            {orders.map((order, idx) => {
                                return (
                                    <div
                                        key={`order-${idx}`}
                                        className="Orders__List_RowWrapper"
                                    >
                                        <div
                                            className="Orders__List_item"
                                            onClick={() =>
                                                setSelectedInvoice(order.name)
                                            }
                                        >
                                            <div>{order.table}</div>
                                            <div>
                                                {getOrderShortName(order.name)}
                                            </div>
                                            <div>{order.total}</div>
                                            <div>
                                                {dateTimeFormat(
                                                    order.posting_time
                                                )}
                                            </div>
                                            <div>{order.total_qty}</div>
                                        </div>
                                        <span className="Orders__List_Action">
                                            <IconButton
                                                onClick={() =>
                                                    handlePrint(order)
                                                }
                                                disabled={printingOrder === order.name}
                                            >
                                                {printingOrder === order.name ? (
                                                    <CircularProgress size={20} />
                                                ) : (
                                                    <Print />
                                                )}
                                            </IconButton>
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Drawer>
            <Dialog
                open={!!selectedInvoice}
                onClose={() => {
                    setSelectedInvoice(null);
                }}
                fullWidth
            >
                <DialogTitle>
                    <Button
                        onClick={() => {
                            setSelectedInvoice(null);
                        }}
                    >
                        Close
                    </Button>
                </DialogTitle>
                <DialogContent>
                    {!!invoiceData ? <InvoiceView /> : <Spinner />}
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default ClosedOrders;
